<script lang="ts">
	import Avatar from '$lib/elements/Avatar.svelte';
	import { getOptimizedCmsImageUrl } from '@app/utils/cms';
	export let interviewer: interviewer;

	interface interviewer {
		firstName: string;
		lastName: string;
		filename: string;
		job: string;
	}
</script>

{#if interviewer.filename}<div class="flex md:justify-start justify-center">
		<Avatar
			imageUrl={getOptimizedCmsImageUrl(interviewer.filename, '250x250')}
			size="big"
			border="none"
			alt={(interviewer?.firstName || '') + (interviewer?.lastName || '')}
			classNames="min-w-[110px] min-h-[110px]   object-cover  rounded-full md:max-w-[151px] max-w-[120px] mb-3 "
		/>
	</div>
	<p class="font-semibold text-xl font-display p-0">
		{interviewer.firstName + ' ' + interviewer.lastName}
	</p>
	{#if interviewer.job}
		<p>{interviewer.job}</p>
	{/if}
{/if}
